import React from 'react'
import { Modal as BaseModal } from '@morningtrain/react-modals'

export default class Modal extends BaseModal {

  get baseClassName () {
    return [
      'modal',
      this.props.className,
    ].join(' ')
  }

}
